<template>
  <div class="bottom-slide-panel" :class="{ 'is-open': show }">
    <div class="panel-header d-flex justify-space-between align-center px-4 py-2" @click="isCollapsed = !isCollapsed"
      style="cursor: pointer;">
      <div class="font-weight-bold text-subtitle-1">
        <v-icon small color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
        Kết quả tìm kiếm
        <span v-if="total > 0" class="grey--text ml-2">({{ total }} kết quả)</span>
      </div>
      <div>
        <v-btn icon small @click.stop="isCollapsed = !isCollapsed" class="mr-2">
          <v-icon>{{ isCollapsed ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
        <v-btn icon small @click.stop="$emit('update:show', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="panel-content px-4 pb-4" v-show="!isCollapsed">
      <SearchResultList :items="results" :total="total" :loading="loading" :page="page"
        @update:page="$emit('update:page', $event)" :limit="limit" :detailLoadingId="detailLoadingId"
        @page-change="p => $emit('page-change', p)" @click:info="onInfoClick"
        @click:export="item => $emit('click:export', item)" />
    </div>
  </div>
</template>

<script>
import SearchResultList from '../modules/AdvancedSearch/SearchResultList.vue'

export default {
  name: 'BottomSlidePanel',
  components: {
    SearchResultList
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    results: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 5
    },
    detailLoadingId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      isCollapsed: false
    }
  },
  watch: {
    results() {
      // Auto expand when new results arrive
      if (this.results && this.results.length > 0) {
        this.isCollapsed = false
      }
    }
  },
  methods: {
    onInfoClick(item) {
      this.$emit('click:info', item)
    },
    collapse() {
      this.isCollapsed = true
    }
  }
}
</script>

<style scoped>
.bottom-slide-panel {
  position: absolute;
  bottom: 0;
  left: 88px; /* Dịch sang trái 64px (24px lề + 48px công cụ + 16px khoảng hở) để không đè Left Toolbar */
  width: 396px; /* 460px (thanh search) - 64px thụt vào = 396px, thẳng hàng mép phải với thanh search */
  max-height: 280px; /* Thu nhỏ chiều cao hơn một chút nữa */
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 -10px 25px -5px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.3s;
  transform: translateY(120%);
  opacity: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.bottom-slide-panel.is-open {
  transform: translateY(0);
  opacity: 1;
}

.panel-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(248, 250, 252, 0.85);
  border-radius: 12px 12px 0 0;
}

.panel-content {
  flex-grow: 1;
  overflow-y: auto;
}
</style>
